<template>
  <el-dialog title="系统提示" :visible.sync="dialogVisible" width="800px">
    <div>
      <i class="el-icon-warning" style="color: #6189f5; font-size: 16px;"></i> 检测到以下店铺素材中心空间容量剩余已不足100MB，可能造成铺货失败，可跳转后台扩容后再铺货。
      <div style="padding: 10px">
        <div v-for="(item, index) in list" :key="item.shopId + index">
          <el-image style="width: 16px; height: 16px; margin-right: 5px; top: 4px" :src="PLATFORM_ICONS_MAP[item.source]"></el-image>
          {{ item.shopName }}
          <span v-if="item.photoAlarm" style="color: red;">(图片容量告警)</span>
          <span v-if="item.videoAlarm" style="color: red; margin-left: 10px;">(视频容量告警)</span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">返 回</el-button>
      <el-button type="primary">
        <a style="color: #fff" href="https://fxg.jinritemai.com/ffa/shop/material/creative" target="_blank">前往扩容</a>
      </el-button>
      <el-button type="primary" @click="continueBulkShelve">继续铺货</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { PLATFORM_ICONS_MAP } from '@dic/platforms.js';

export default {
  data() {
    return {
      dialogVisible: false,
      PLATFORM_ICONS_MAP,
      opts: {},
      list: [],
    };
  },
  methods: {
    method_open(opts) {
      this.dialogVisible = true;
      this.opts = opts;
      this.list = opts.capacityList.map(item => {
        return {
          ...item,
          source: opts.source,
          shopName: this.formatShopNameById(item.shopId),
        };
      });
    },
    continueBulkShelve() {
      this.dialogVisible = false;
      this.$emit('continueBulkShelve');
    },
    formatShopNameById(shopId) {
      return (this.$store.getters.shops_getById(shopId) || {}).title;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
